package com.sweetlime.bingeamigo.model

data class LibraryItem(
    val id: Int,
    val title: String,
    val posterPath: String?,
)

fun LibraryMovie.toLibraryItem() = LibraryItem(id, movie.title, movie.posterPath)
fun LibraryTvShow.toLibraryItem() = LibraryItem(id, tvShow.name, tvShow.posterPath)
